import { render, staticRenderFns } from "./LLTabs2.vue?vue&type=template&id=2534166c&scoped=true"
import script from "./LLTabs2.vue?vue&type=script&lang=js"
export * from "./LLTabs2.vue?vue&type=script&lang=js"
import style0 from "./LLTabs2.vue?vue&type=style&index=0&id=2534166c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2534166c",
  null
  
)

export default component.exports